<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <p>IP адреса, которые распознаются как поисковые системы</p>
        <div class="row">
          <div class="col-md-3">
            <input v-model="searchData" placeholder="0.0.0.0" type="text" class="form-control">
          </div>
          <div class="col-md-9 flex">
            <LoadingButton
              title="Проверить запись IP"
              className="btn btn-outline-info"
              :onClick="() => checkIp()"
              :loading="loading"
              :color="$constants.PRIMARY_COLOR"
            />
            <LoadingButton
              title="Добавить IP"
              className="ml-1 btn btn-outline-success"
              :onClick="() => checkIp(true)"
              :loading="loading"
              :color="$constants.SUCCESS_COLOR"
            />
          </div>
        </div>
      </div>
    </div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div class="card" v-if="!loading && record !== false">
      <div class="card-body">
        <template v-if="!record">
          <p>Запись не найдена</p>
        </template>
        <template v-else>
          <p>{{ record }}
            <LoadingButton
              title="Удалить IP"
              className="btn btn-outline-danger"
              :onClick="() => checkIp(false, true)"
              :loading="loading"
              :color="$constants.WARNING_COLOR"
            />
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    LoadingButton
  },
  data() {
    return {
      loading: false,
      searchData: null,
      record: false,
    }
  },
  methods: {
    async checkIp(save = false, del = false) {
      if (!this.searchData) return;
      this.record = null;
      this.loading = true;
      const {data} = await api.post('/new/redis/checkip', {
        save,
        delete: del,
        ip: this.searchData
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
      } else {
        this.record = data.record;
        if (save) {
          toastr['success'](data.message || 'Сохранено');
        }
      }
      this.loading = false;
    }
  }
}
</script>
